import { loadScriptTag } from '../utils/scriptLoader';

export const loadBaremetricsRecoverWidget = (customerId) => {
  const barepay = window.document.createElement('barepay');
  window.document.body.appendChild(barepay);
  /* eslint-disable */
  loadScriptTag({
    innerContent: `!function(){if(window.barepay&&window.barepay.created)window.console&&console.error&&console.error("Barepay snippet included twice.");else{window.barepay={created:!0};var a=document.createElement("script");a.src="https://baremetrics-dunning.baremetrics.com/js/application.js",a.async=!0;var b=document.getElementsByTagName("script")[0];b.parentNode.insertBefore(a,b),window.barepay.params={access_token_id:"2f3d6f54-11b2-4d3b-aa22-c1d023eeb3e7",customer_oid:"${customerId}"}}}();`
  });
  /* eslint-enable */
};



// WEBPACK FOOTER //
// ./src/app/admin/services/thirdParty/BaremetricsRecover.js